export class AuthV2ForgotPasswordResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "deliveryMedium",
            "baseName": "deliveryMedium",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuthV2ForgotPasswordResponse.attributeTypeMap;
    }
    constructor() {
    }
}
